export function TableLoadingCell() {
  return (
    <div className="w-full border h-full flex overflow-hidden border-transparent bg-neutral-1 items-center">
      <div className="flex w-full items-center h-full px-4">
        <div className="w-6 h-6 border-[2px] rounded-full border-primary-6 border-t-transparent animate-spin" />
      </div>
    </div>
  );
}
